export var DEFAULT_REQUEST_OPTIONS = {
    credentials: 'include',
    isErrorTextStraightToOutput: true,
};
